import { parsePhoneNumberWithError } from 'libphonenumber-js'

export const formatString = {
  /**
   * Capitalizes the first letter of a string and lowercases the rest
   * @param str The string to capitalize
   */
  toFirstLetterCapitalized: (str?: string): string => {
    if (!str?.trim()) return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
  },

  /**
   * Capitalizes the first letter of each word in the string
   * @param str The string to convert to title case
   */
  toTitleCase: (str: string): string =>
    str
      .split(' ')
      .map((word) => formatString.toFirstLetterCapitalized(word))
      .join(' '),

  /**
   * Formats an address by trimming whitespace and ensuring proper comma separation
   * @param address The address string to format
   */
  toFormattedAddress: (address?: string): string => {
    if (!address) return address ?? ''

    return address
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean)
      .join(', ')
  },

  /**
   * Formats a phone number to the national format
   * @param phone The phone number string to format
   */
  toFormattedPhoneNumber: (phone?: string) => {
    if (!phone) return phone

    const digits = phone.replace(/\D/g, '')

    if (digits.length === 7) {
      /**
       * Format 7-digit numbers as XXX-XXXX
       */
      const prefix = digits.slice(0, 3)
      const lineNumber = digits.slice(3)

      return `${prefix}-${lineNumber}`
    }

    try {
      return parsePhoneNumberWithError(phone, 'US').formatNational()
    } catch {
      return phone
    }
  },
}
